import React from 'react';
import { Button, Card, Empty } from 'antd';
import { PlusOutlined, RightOutlined } from '@ant-design/icons';
import styles from './SummaryCard.less';
import { F } from '@/utils/intl';
import classNames from 'classnames';

export interface SummaryCardProps {
  title: React.ReactChild | string;
  count: number;
  children: React.ReactNode;
  showEmpty?: boolean;
  onAdd?: (e: MouseEvent) => void;
  onShowAll?: () => void;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  count,
  children,
  showEmpty,
  onAdd,
  onShowAll,
}) => {
  const hasItems = count > 0;
  return (
    <Card className={styles.summaryCard}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        {onAdd && (
          <Button
            variant={'filled'}
            color={'secondary'}
            icon={<PlusOutlined />}
            onClick={onAdd}
            size="small"
            className={styles.addButton}
          />
        )}
      </div>

      <div className={classNames(styles.content, {
        [styles.hasContent]: hasItems
      })}>
        {hasItems ? (
          children
        ) : showEmpty ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            className={styles.empty}
          />
        ) : null}
        {onShowAll && hasItems && (
          <Button onClick={onShowAll} className={styles.showAllButton}>
            <F
              id={'common.actions.show_all_count'}
              defaultMessage={'Show All {x}'}
              values={{ x: count }}
            />
            <RightOutlined />
          </Button>
        )}
      </div>
    </Card>
  );
};

export default SummaryCard;
